import React, { useState } from 'react';
import { CallContext } from '@varos/call-core';
import { assertNever } from '@varos/util-typescript';
import { ChatContainerBaseConfig } from '../../../base';
import { CallRequestNewContainerProps } from '../new';
import { CallRequestDetailContainerProps } from '../detail';
import {
    CallRequestUpsertController,
    CallRequestUpsertLoader,
} from './callRequestUpsertInterface';
import { CallRequestUpsertContainerProps } from './callRequestUpsertProps';

export function createCallRequestUpsertContainer(
    config: ChatContainerBaseConfig & {
        Container: {
            New: React.FC<CallRequestNewContainerProps>;
            Detail: React.FC<CallRequestDetailContainerProps>;
        };
    },
    loader: CallRequestUpsertLoader,
    controller: CallRequestUpsertController
): React.FC<CallRequestUpsertContainerProps> {
    const {
        context: { useContext },
        Container: { New: NewContainer, Detail: DetailContainer },
    } = config;

    return ({ as, ...containerProps }) => {
        const { New: NewView, Detail: DetailView } = as;
        const context = useContext();
        const [callContext, setCallContext] = useState<CallContext | null>(null);
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            context: {
                value: callContext,
                onChange(context) {
                    setCallContext(context);
                },
            },
            onEnd(call) {
                return containerProps.onEnd(call);
            },
        });
        if (props.status.kind === 'calling') {
            return <NewContainer as={NewView} {...props.status.component} />;
        }
        if (props.status.kind === 'ready') {
            return <DetailContainer as={DetailView} {...props.status.component} />;
        }
        assertNever(props.status);
    };
}
